// import React, { useState, useEffect, useRef } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { Typewriter } from "react-simple-typewriter";
// import { FaPhone, FaEnvelope, FaBars, FaTimes, FaSun, FaMoon, FaChevronDown } from "react-icons/fa";
// import { motion, AnimatePresence } from "framer-motion";

// const LandingNavbar = () => {
//   const navigate = useNavigate();
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [isHidden, setIsHidden] = useState(false);
//   const [lastScrollY, setLastScrollY] = useState(0);
//   const [isScrolled, setIsScrolled] = useState(false);
//   const dropdownRef = useRef(null);
//   const mobileMenuRef = useRef(null);

//   // Theme toggle
//   const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");

//   useEffect(() => {
//     if (theme === "dark") {
//       document.documentElement.classList.add("dark");
//     } else {
//       document.documentElement.classList.remove("dark");
//     }
//     localStorage.setItem("theme", theme);
//   }, [theme]);

//   const toggleTheme = () => {
//     setTheme(theme === "dark" ? "light" : "dark");
//   };

//   return (
//     <motion.header
//       className="fixed w-full top-0 z-50"
//       animate={isHidden ? "hidden" : "visible"}
//       variants={{ visible: { y: 0 }, hidden: { y: "-100%" } }}
//       transition={{ duration: 0.3, ease: "easeInOut" }}
//       ref={mobileMenuRef}
//     >
//       {/* Top Bar */}
//       <div className="bg-gradient-to-r from-gray-900 to-black text-gray-300 text-sm py-2 px-4 border-b border-gray-800">
//         <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center">
//           <div className="flex items-center gap-3 mb-2 md:mb-0">
//             <Typewriter
//               words={[
//                 "Unmatched Access to Luxury Retreats",
//                 "Elite Rewards & VIP Experiences",
//               ]}
//               loop={0}
//               cursor
//               cursorStyle="|"
//               typeSpeed={50}
//               deleteSpeed={30}
//               delaySpeed={2500}
//             />
//           </div>
//           <div className="flex items-center gap-4">
//             <FaEnvelope className="text-blue-400 hidden sm:block" />
//             <span className="text-xs sm:text-sm">prince@tripocationholiday.com</span>
//             <FaPhone className="text-blue-400 hidden sm:block" />
//             <span className="text-xs sm:text-sm">+91 92201 98202</span>
//           </div>
//         </div>
//       </div>

//       {/* Main Navbar */}
//       <nav className={`bg-gray-900 dark:bg-black transition-shadow duration-300 ${isScrolled ? "shadow-xl" : ""}`}>
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex justify-between items-center h-20">
//             <div
//               className="flex items-center cursor-pointer"
//             >
//               <img
//                 src="/tripocation.jpg"
//                 alt="Logo"
//                 className="w-12 h-12 md:w-16 md:h-16 object-contain"
//               />
//               <div className="ml-3">
//                 <p className="text-xs text-gray-400">Explore the world with</p>
//                 <h1 className="text-xl font-bold text-white">Tripocation Holiday</h1>
//               </div>
//             </div>

//             {/* Mobile Menu Toggle */}
//             <button
//               className="md:hidden p-2 text-gray-400 hover:text-white"
//               onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
//             >
//               {isMobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
//             </button>
//           </div>
//         </div>

//         {/* Mobile Menu */}
//         {isMobileMenuOpen && (
//           <motion.div
//             initial={{ height: 0, opacity: 0 }}
//             animate={{ height: "auto", opacity: 1 }}
//             exit={{ height: 0, opacity: 0 }}
//             className="md:hidden bg-gray-800 text-gray-200 px-4 pt-2 pb-4 space-y-2"
//           >
//             {/* Theme Toggle for Mobile */}
//             <div
//               onClick={toggleTheme}
//               className="w-12 h-6 flex items-center bg-gray-500 rounded-full p-1 cursor-pointer mt-2"
//             >
//               <div
//                 className={`bg-white w-4 h-4 rounded-full shadow-md transform transition-transform duration-300 ${theme === "dark" ? "translate-x-6" : ""
//                   }`}
//               ></div>
//             </div>
//           </motion.div>
//         )}
//       </nav>
//     </motion.header>
//   );
// };

// export default LandingNavbar;
import React, { useState, useEffect, useRef } from "react";
import { FaPhone, FaEnvelope, FaBars, FaTimes, FaSun, FaMoon } from "react-icons/fa";
import { motion } from "framer-motion";

const LandingNavbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");

  useEffect(() => {
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(theme === "dark" ? "light" : "dark");
  };

  return (
    <motion.header className="fixed w-full top-0 z-50">
      {/* Top Bar (White background, black text) */}
      <div className="bg-white text-black font-semibold text-sm py-2 px-4 shadow-sm">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          {/* Logo */}
          <div className="flex items-center gap-3 cursor-pointer">
            <img
              src="/tripocation.jpg"
              alt="Tripocation Logo"
              className="w-12 h-12 md:w-16 md:h-16 object-contain"
            />
            <div className="ml-1">
              <p className="text-xs text-gray-600">Explore the world with</p>
              <h1 className="text-lg font-bold text-black">Tripocation Holiday Pvt. Ltd.</h1>
            </div>
          </div>

          {/* Contact Info */}
          <div className="flex items-center gap-5 text-sm">
            <div className="flex items-center gap-2">
              <FaEnvelope className="text-blue-600" />
              <span>prince@tripocationholiday.com</span>
            </div>
            <div className="flex items-center gap-2">
              <FaPhone className="text-blue-600" />
              <span>+91 92201 98202</span>
            </div>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className="md:hidden text-gray-700 ml-4"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile Dropdown */}
      {isMobileMenuOpen && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          className="md:hidden bg-white text-black px-4 pt-2 pb-4 space-y-2"
        >
          <div
            onClick={toggleTheme}
            className="w-12 h-6 flex items-center bg-gray-300 rounded-full p-1 cursor-pointer mt-2"
          >
            <div
              className={`bg-white w-4 h-4 rounded-full shadow-md transform transition-transform duration-300 ${theme === "dark" ? "translate-x-6" : ""
                }`}
            ></div>
          </div>
        </motion.div>
      )}
    </motion.header>
  );
};

export default LandingNavbar;
